import { SearchResultEnqueteRepository } from '../../repositories/search_result_enquete/search_result_enquete_repository';
import { SearchResultEnquete } from '../../models/search_result_enquete/search_result_enquete';
import { SearchResultEnqueteJsEnv } from '../../models/search_result_enquete/search_result_enquete_js_env';
import { TypedEvent } from '../../typed_event';
import { SearchResultEnqueteContainer } from '../../views/pc/search_result_enquete/search_result_enquete_container';
import { JsEnv } from '../../models/js_env';

export class SearchResultEnqueteAction {
  static readonly UPDATE_EVENT = new TypedEvent<SearchResultEnqueteJsEnv>();
  private static state: SearchResultEnquete;
  private static searchResultEnqueteRepository: SearchResultEnqueteRepository;

  static async init(env: JsEnv) {
    this.searchResultEnqueteRepository = new SearchResultEnqueteRepository();
    this.state = new SearchResultEnquete(new SearchResultEnqueteJsEnv(
      env.PAGE.llCategoryCode,
      env.PAGE.lCategoryCode,
      env.PAGE.mCategoryCode,
      env.PAGE.sCategoryCode,
      env.PAGE.searchKeyWord,
      env.PAGE.userTracking,
      env.PAGE.userId,
      env.PAGE.companyId,
      env.PAGE.departmentId,
      env.PAGE.categoryType,
    ));
    new SearchResultEnqueteContainer();// NOSONAR
  }

  static setEnqueteAnswer(isUseful: boolean) {
    this.state.setIsUseful(isUseful);
  }

  static sendSearchResultEnquete(enqueteMessage: HTMLTextAreaElement) {
    this.state.setEnqueteMessage(enqueteMessage.value.trim());
    const model = this.state.getModel();
    this.searchResultEnqueteRepository.sendResuqest(model);
  }
}
